import { Box, Grid } from "@mui/material";
import { IDialogContextGeneric } from "../../../../../../components/BasicComponents/GenericModalContext";
import DialogFullScreen from "../../../../../../components/DialogFullScreen";
import axiosClient from "../../../../../../lib/axios";
import { useQuery } from "react-query";
import DetalheCooperadoSkeleton from "./DetalheCooperadoSkeleton";
import { IDataDetalharCooperado } from "../../../../../../types/api/cadastros/detalhar-cooperado";
import CardDadosCadastrais from "./CardDadosCadastrais";
import CardFazendas from "./CardFazendas";
import CardDadosFinanceiros from "./CardDadosFinanceiros";
import CardResumo from "./CardResumo";
import CardHistoricoSituacao from "./CardHistoricoSituacao";
import CardRelacionamento from "./CardRelacionamento";
import CardCompradoresAutorizados from "./CardCompradoresAutorizados";

export default function DialogDetalheCooperado({
    open,
    value,
    handleClose
}: IDialogContextGeneric<string>) {

    const { data, isLoading } = useQuery({
        queryKey: ['cadastros/detalhar-cooperado', value],
        queryFn: () => axiosClient.get(`/cadastros/detalhar-cooperado/${value}`),
    })

    const publico: IDataDetalharCooperado = data?.data || null
    const carregando = isLoading || !publico

    return (
        <DialogFullScreen
            {...{ open, handleClose }}
            title="Detalhe do Cooperado"
        >
            {carregando && <DetalheCooperadoSkeleton />}

            {!carregando && (
                <Box p={2}>
                    <Grid container spacing={3}>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12 }}>
                                    <CardResumo data={publico} />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <CardHistoricoSituacao data={publico.historico_situacao_financeira} />
                                </Grid>

                                <Grid size={{ xs: 12 }}>
                                    {/* <CardUltimasCompras produtoId={produto.id} /> */}
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    {/* <CardUltimasVendas produtoId={produto.id} /> */}
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12, md: 8 }}>
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12 }}>
                                    <CardDadosCadastrais data={publico} />
                                </Grid>
                                {
                                    publico.tipo_publico === 'A' &&
                                    <>
                                        <Grid size={{ xs: 12 }}>
                                            <CardFazendas data={publico} />
                                        </Grid>

                                        <Grid size={{ xs: 12 }}>
                                            <CardDadosFinanceiros
                                                data={publico}
                                            />
                                        </Grid>

                                        <Grid size={{ xs: 12 }}>
                                            <CardRelacionamento data={publico} />
                                        </Grid>

                                        <Grid size={{ xs: 12 }}>
                                            <CardCompradoresAutorizados data={publico} />
                                        </Grid>
                                    </>
                                }

                                <Grid size={{ xs: 12 }}>
                                    {/* <CardUltimasVendasMensais
                                        produtoId={produto.id}
                                    /> */}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            )}
        </DialogFullScreen>

    );
}

export interface CardProps {
    data: IDataDetalharCooperado
}